import { useCallback, useState } from 'react';
import { apiClient } from '../api/client';
import { POLITICA_VAZIA, PoliticaDeAcesso, corpoParaSalvar, mensagemDeErroDaPolitica } from '../utils/accessPolicy';

/**
 * Regras de acesso da organização ativa (Etapa 18, só owner/admin).
 * `save` e `testIp` lançam o erro: quem chama decide (ex.: pedir a confirmação extra do IP).
 */
export function useAccessPolicy() {
  const [policy, setPolicy] = useState<PoliticaDeAcesso | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchPolicy = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      setPolicy({ ...POLITICA_VAZIA, ...(await apiClient.get<PoliticaDeAcesso>('/access-policy')) });
    } catch (err) {
      setError(mensagemDeErroDaPolitica(err));
    } finally {
      setIsLoading(false);
    }
  }, []);

  const save = async (politica: PoliticaDeAcesso, confirmarIp: boolean) => {
    const salva = await apiClient.put<PoliticaDeAcesso>('/access-policy', corpoParaSalvar(politica, confirmarIp));
    setPolicy({ ...POLITICA_VAZIA, ...salva });
    return salva;
  };

  const testIp = (faixas: string[]) =>
    apiClient.post<{ ip: string | null; allowed: boolean }>('/access-policy/test-ip', { allowed_cidrs: faixas });

  return { policy, isLoading, error, fetchPolicy, save, testIp };
}
